// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Hata Kodu:",
    "error.search": "Daha fazla bilgi edinmek için bilgi tabanımıza göz at",
    dismiss: "kapat",
    "installation.title": "",
    "cancelation.button": "İptal",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Başlatma Başarısız",
      description: "Sayfayı işleyemedik. Lütfen destek ile iletişime geç.",
    },
    "EOS-UI-UE": {
      title: "Bir sorun oluştu.",
      description: "Bir sorun oluştu. Lütfen destek ile iletişime geç.",
    },
    "EOS-IN-BC": {
      title: "Yükleme Başarısız",
      description:
        "Yükleme sürecini gösteremedik. Lütfen destek ile iletişime geç.",
    },
    "EOS-IN-UE": {
      title: "Yükleme Başarısız",
      description: "Bir sorun oluştu. Lütfen destek ile iletişime geç.",
    },
    "EOS-IN-FF": {
      title: "Yükleme Başarısız",
      description:
        "Epic Online Services'a bağlanamadık. Lütfen destek ile iletişime geç.",
    },
    "EOS-IN-FF-*": {
      title: "Yükleme Başarısız",
      description:
        "Talebi Epic Online Services'a iletemedik. Lütfen destek ile iletişime geç.",
    },
    fallback: {
      title: "Bir sorun oluştu.",
      description: "Bir sorun oluştu. Lütfen destek ile iletişime geç.",
    },
  },
};
